import React from 'react';
import { css } from 'aphrodite';
import styles from './available-drivers-map-styles';
import LiveLocationMarker from '../map-markers/live-location-marker';
import HomeLocationMarker from '../map-markers/home-location-marker';
import { ContentCard, ContentRow, Switch } from '../common';
import DriverCard from '../map-markers/driver-card';
import Map from '../map/map';

const AvailableDriversMapView = (props) => (
  <div className={css(styles.root)}>
    <ContentCard title={'Map filters'}>
      <ContentRow>
        <div>Show home locations</div>
        <div style={{ flex: 1 }} />
        <Switch checked={props.showHomeLocations} onChange={props.toggleHomeLocations} />
      </ContentRow>
    </ContentCard>

    <ContentCard title={'Available drivers map'}>
      <Map center={props.center} zoom={props.zoom}>
        {props.availableDriversMap.currentDriver && <DriverCard
          lat={props.availableDriversMap.currentDriverLat}
          lng={props.availableDriversMap.currentDriverLng}
          driver={props.availableDriversMap.currentDriver}
        />}

        {props.showHomeLocations && props.driverHomeLocations.map((driver, index) => (
          <HomeLocationMarker
            key={index}
            lat={driver.home.latitude}
            lng={driver.home.longitude}
            driver={driver}
          />
        ))}

        {props.liveDriverLocations.map((driver, index) => (
          <LiveLocationMarker
            key={index}
            lat={driver.lastLocation.latitude}
            lng={driver.lastLocation.longitude}
            driver={driver}
          />
        ))}
      </Map>
    </ContentCard>
  </div>
);

export default AvailableDriversMapView;



// WEBPACK FOOTER //
// ./src/components/available-drivers-map/available-drivers-map-view.js